import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as auth from "modules/Auth/_redux/authRedux";
// import { toast } from "react-toastify";
// import { info } from "modules/Auth/_redux/authCrud";
// import { GoogleLogin } from "react-google-login";
import JWTService from "@core/auth/JWTService";
import PhoneField from "./parts/PhoneField";
import {
  isValidTurkishPhoneNumber,
  phoneFlatFormat,
} from "../../helpers/PhoneFormats";
import { toast } from "react-toastify";
import "./Login.css";

function SmsOtp(props) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    phone: "",
    phoneFlat: "",
  });
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);

  function saveGsmNo(e) {
    e.preventDefault();

    const isValid = isValidTurkishPhoneNumber(form.phone);
    if (!isValid)
      return toast.error("Lütfen geçerli bir telefon numarası girin");

    JWTService.saveGsmNo(form.phoneFlat)
      .then((userInformation) => {
        setSent(true);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function signOut(e) {
    props.logout();
  }

  function verifyGsmNo(e) {
    e.preventDefault();
    // setLoading(true);
    JWTService.verifyGsmNo(code)
      .then((userInformation) => {
        props.setUser(userInformation.user);
      })
      .then(() => {
        const pageToRedirectAfterLogin = localStorage.getItem(
          "pageToRedirectAfterLogin"
        );

        props.history.push(
          pageToRedirectAfterLogin ? pageToRedirectAfterLogin : `/`
        );
        localStorage.removeItem("pageToRedirectAfterLogin");
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function handlePhoneChange(event) {
    event.persist();
    setForm((prevState) => ({
      ...prevState,
      phone: event.target.value,
      phoneFlat: phoneFlatFormat(event.target.value),
    }));
  }

  return (
    <div className="auth-split">
      <div className="auth-split__brand">
        <div className="auth-split__brand-decor" />
        <div className="auth-split__brand-decor auth-split__brand-decor--2" />

        <div className="auth-split__headline">
          <h2>Son bir adım kaldı.</h2>
          <p>
            Hesabını doğrulamak için telefon numaranı onayla. Böylece ilanların
            güvende, alıcı ve satıcılarla mesajlaşman kesintisiz olur.
          </p>
        </div>

        <ul className="auth-split__points">
          <li>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
            Numaranı gir, SMS ile kodun gelsin
          </li>
          <li>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
            Kodu onayla, hesabın aktifleşsin
          </li>
          <li>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
            İlan ver, mesajlaş, güvenle anlaş
          </li>
        </ul>
      </div>

      <div className="auth-split__form">
        <div className="auth-split__card">
          <div className="auth-split__logo">
            <Link to={"./"}>
              <img src={require("images/alicilar-logo.png")} alt="" />
            </Link>
          </div>
          <div id="login">
            <form className="dez-form">
              <h5 className="form-title m-t0">Telefon Doğrulama</h5>
              <div className="dez-separator-outer m-b5">
                <div className="dez-separator bg-primary style-liner" />
              </div>

              <div className="form-group">
                <PhoneField
                  value={form.phone}
                  onChange={(e) => handlePhoneChange(e)}
                />
              </div>

              {sent && (
                <div className="form-group">
                  <input
                    autoFocus
                    name="code"
                    required
                    className="form-control "
                    value={form.code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Doğrulama kodunu giriniz"
                    type="number"
                  />
                </div>
              )}

              <div className="form-group text-left">
                <div className="d-flex justify-content-between align-items-center">
                  {!sent && (
                    <button
                      className="site-button dz-xs-flex m-r5"
                      disabled={loading}
                      onClick={saveGsmNo}
                    >
                      {loading ? "Yükleniyor.." : "Doğrula"}
                    </button>
                  )}

                  {sent && (
                    <button
                      className="site-button dz-xs-flex m-r5"
                      disabled={loading}
                      onClick={verifyGsmNo}
                    >
                      {loading ? "Yükleniyor.." : "Doğrula"}
                    </button>
                  )}
                  <button
                    className="site-button dz-xs-flex m-r5 bg-secondary"
                    onClick={signOut}
                  >
                    Çıkış
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="auth-split__footer">
            © Copyright by{" "}
            <Link to={"/"}>
              Alıcılar Bilgi Teknolojileri Pazarlama ve Ticaret A.Ş.
            </Link>{" "}
            All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, auth.actions)(withRouter(SmsOtp));
